var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1528,
    height: 1528,
    viewBox: "0 0 1528 1528",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_130_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1164 0H364C165.6 0 4 161.6 4 360V1160C4 1358.4 165.6 1520 364 1520H1164C1362.4 1520 1524 1358.4 1524 1160V360C1524 161.6 1362.4 0 1164 0ZM941.6 811.2L1066.4 936.003C1101.6 971.2 1104.8 1032 1068 1067.2C1050.4 1083.2 1028 1091.2 1005.6 1091.2C983.199 1091.2 959.199 1083.2 941.6 1065.6L813.6 937.601C784.798 908.799 740.002 908.799 711.199 937.601L583.199 1065.6C565.6 1083.2 543.199 1091.2 519.199 1091.2C496.798 1091.2 474.396 1083.2 456.798 1067.2C419.995 1032 421.6 971.2 458.397 936.003L583.199 811.2C612.002 782.397 612.002 737.601 583.199 708.799L461.601 584.001C426.403 548.804 423.199 492.804 456.798 456.001C491.996 419.199 549.601 417.6 584.798 454.402L712.798 582.402C741.601 611.205 786.397 611.205 815.2 582.402L943.2 454.402C978.397 419.205 1037.6 419.205 1071.2 456.001C1104.8 491.199 1101.6 548.804 1066.4 584.001L941.595 708.804C914.402 737.601 914.402 782.403 941.6 811.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.37 1070.9L1071.41 1070.86L1071.46 1070.81C1110.53 1033.44 1106.87 969.4 1069.94 932.467L945.188 807.717C919.873 780.862 919.872 739.144 945.182 712.289L1069.93 587.537C1106.83 550.644 1110.49 489.965 1074.86 452.591C1039.24 413.629 976.768 413.763 939.664 450.867L811.664 578.867C784.814 605.717 743.184 605.717 716.334 578.867L588.373 450.906C551.09 411.967 490.223 413.818 453.185 452.546L453.145 452.587L453.106 452.63C417.585 491.538 421.113 550.56 458.04 587.512C458.048 587.52 458.057 587.529 458.065 587.537L579.618 712.288L579.641 712.311L579.664 712.334C606.514 739.184 606.514 780.814 579.664 807.665L454.9 932.428C416.202 969.488 414.378 1033.55 453.342 1070.81L453.387 1070.86L453.434 1070.9C471.996 1087.77 495.612 1096.2 519.199 1096.2C544.363 1096.2 568.09 1087.78 586.734 1069.14L714.734 941.137C741.584 914.287 783.215 914.287 810.065 941.137L938.065 1069.14C956.739 1087.81 982.082 1096.2 1005.6 1096.2C1029.19 1096.2 1052.8 1087.77 1071.37 1070.9ZM364 5H1164C1359.64 5 1519 164.361 1519 360V1160C1519 1355.64 1359.64 1515 1164 1515H364C168.361 1515 9 1355.64 9 1160V360C9 164.361 168.361 5 364 5Z",
    stroke: "black",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_130_3",
    x: 0,
    y: 0,
    width: 1528,
    height: 1528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_130_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_130_3",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.db6c89978dc9190aa254e5f0e7c5789d.svg";
export { ForwardRef as ReactComponent };